import { useEffect } from 'react';
import { type TFunction, type TransComponent } from '@pkgs/components/providers/AppContextProvider';
import { SignInModal, type SignInModalProps, useAuth } from '@ev-tech/user-account-modules';
import { type ModalState } from '@ev-tech/ui-core-components/Modal';
import { CountryCode, Language } from '@ev-tech/search-modules-api';

import { useUserAccountStatusMessages } from './useUserAccountStatusMessages';

export const Trigger = {
  Favorites: 'favorites',
  SavedSearch: 'savedSearch',
} as const;

export type UserAccountModalProps = {
  modalState: ModalState;
  t: TFunction;
  transComponent: TransComponent;
  countryCode?: string;
  language?: string;
  trigger?: SignInModalProps['trigger'];
  triggerId?: string;
  tracking?: SignInModalProps['tracking'];
  onOpenChange: (isOpen: boolean) => void;
};

export const UserAccountModal = ({
  modalState,
  t: tFunc,
  transComponent: TransComponent,
  countryCode = CountryCode.DE,
  language = Language.en,
  trigger,
  triggerId,
  tracking,
  onOpenChange,
}: UserAccountModalProps) => {
  const { isSignedIn } = useAuth();
  const { isOpen, close } = modalState;
  const statusMessageCallbacks = useUserAccountStatusMessages({ tFunc, transComponent: TransComponent });

  useEffect(() => {
    if (isSignedIn) {
      close();
    }
  }, [isSignedIn, close]);

  return (
    <SignInModal
      tFunc={tFunc}
      initialStep="signIn"
      country={countryCode.toLowerCase()}
      language={language}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      onCloseButtonClick={close}
      tracking={{
        ...tracking,
        pageType: tracking?.pageType ?? '',
        templateType: tracking?.templateType ?? '',
        shopId: tracking?.shopId ?? '',
      }}
      trigger={trigger}
      triggerId={triggerId ?? ''}
      {...statusMessageCallbacks}
    />
  );
};
